import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Droplets } from "lucide-react";

export const ProtectedRoute = ({ children, adminOnly = false, managerOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3 text-slate-400">
          <Droplets className="h-8 w-8 animate-pulse text-blue-600" strokeWidth={1.5} />
          <span className="text-sm">Cargando…</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (managerOnly && !["admin", "avanzado"].includes(user.role)) return <Navigate to="/" replace />;

  return children;
};
